import { render } from "./PostYearCarnageReport.vue?vue&type=template&id=5f8d3d6e&scoped=true&ts=true"
import script from "./PostYearCarnageReport.vue?vue&type=script&lang=ts"
export * from "./PostYearCarnageReport.vue?vue&type=script&lang=ts"

import "./PostYearCarnageReport.vue?vue&type=style&index=0&id=5f8d3d6e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8d3d6e"]])

export default __exports__